import { createSelector } from 'reselect';

const userIds = (state) => state.users.ids;

export const getUsersById = (state) => state.entities.users;

export const getUsersIsLoading = (state) => state.users.isLoading;

export const getEditingUserId = (state) => state.users.editingUserId;

export const getEditingUserIsLoading = (state) => state.users.editingUserIsLoading;

export const getEditingUser = createSelector(
  [getUsersById, getEditingUserId],
  (users, id) => users[id],
);

export const getAllUsers = createSelector(
  [getUsersById, userIds],
  (users, ids) => ids.map((id) => users[id]),
);

export const getUsersSelectOptions = createSelector(
  [getUsersById, userIds],
  (users, ids) => ids
    .filter((id) => !!users[id].isActive)
    .map((id) => ({
      value: id,
      label: `${users[id].firstName} ${users[id].lastName}`,
    })),
);
